import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt } from '@fortawesome/free-solid-svg-icons'

function BalanceCard4({name,icon,symbol, type, currency, price, amount, amountUSD}) {
    return (
      <div className="position-relative rounded-3 p-3" style={{backgroundColor: '#ffffff0d'}}>
        <div className="position-absolute d-flex align-items-center justify-content-center rounded-2 shadow overflow-hidden" style={{height: '40px',width:'40px',top:'-20px',backgroundColor: '#ffffff18'}}>
            {icon}
        </div>
        <div className='d-flex align-items-center justify-content-between mt-1'>
            <div>
                <p className="fs-5 fw-bold mb-0">{name}</p>
                <p className="mb-0" style={{fontSize: '12px'}}>{symbol} | {type} | {currency}{price}</p>
            </div>
            <div className="text-end">
                <p className="fs-5 fw-bold mb-0"><span className="text-success">+</span> {currency}{amountUSD}</p>
                <p className="mb-0" style={{fontSize: '12px'}}>{amount} {symbol}</p>
            </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
            <Link to="/deposit" className="me-2 px-3 py-2 d-flex align-items-center rounded-2" style={{backgroundColor: '#ffffff06',textDecoration:'none'}}>
                <FontAwesomeIcon className="text-prime lh-1 me-2" icon={faBolt} style={{fontSize:'14px'}} />
                <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Deposit</p>
            </Link>
            <Link to="/withdraw" className="px-3 py-2 d-flex align-items-center rounded-2" style={{backgroundColor: '#ffffff06',textDecoration:'none'}}>
                <FontAwesomeIcon className="text-prime lh-1 me-2" icon={faBolt} style={{fontSize:'14px'}} />
                <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Withdraw</p>
            </Link>
        </div>
      </div>
    )
  }
  
  export default BalanceCard4